import React from 'react';
import * as ReactDOM from 'react-dom';
class PortalsComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }
    componentDidMount(){
        this.props.offsetclientY();
    }
    render() {
        return ReactDOM.createPortal(
          this.props.children,
          this.props.el
        );
    }
}
export default PortalsComponent;



// WEBPACK FOOTER //
// ./src/display/components/PortalsComponent/index.tsx